import { useFormContext, useWatch } from 'react-hook-form';

import { MAX_NUMBER_VALUE } from '@xemplo/gp-constants';
import { ChangeTaskTypes } from '@xemplo/gp-types';
import { amendmentRateUnitFieldValidation } from '@xemplo/gp-utils';
import { NumberFieldRhf } from '@xemplo/number-field';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

import { AmountMethodOptions } from './bulk-upload/bulk-upload.types';

export const Units = () => {
  const { control } = useFormContext<FormFields>();

  const changeTask = useWatch({ control, name: 'changeTask' });
  const amountMethod = useWatch({ control, name: 'amountMethod' });

  const showUnitsField =
    amountMethod !== AmountMethodOptions.Variable &&
    validChangeTaskTypes.includes(changeTask);

  if (!showUnitsField) return null;
  return (
    <S.FormLabel>
      Unit/s
      <NumberFieldRhf
        aria-label="Units field"
        name="units"
        onWheel={(e) => e.currentTarget.blur()}
        placeholder="Enter units"
        rules={{
          deps: ['recurringMaxAmount', 'rate'],
          required: 'Units field is required',
          min: {
            value: 1,
            message: 'Field min value is 1',
          },
          max: {
            value: MAX_NUMBER_VALUE,
            message: `Field max value is ${MAX_NUMBER_VALUE}`,
          },
          validate: (value, { recurringMaxAmount, rate }) =>
            amendmentRateUnitFieldValidation(value, rate, recurringMaxAmount),
        }}
      />
    </S.FormLabel>
  );
};

const validChangeTaskTypes = [ChangeTaskTypes.ALLOWANCE, ChangeTaskTypes.SALARY];
